import React, { Component } from 'react';
import { Redirect } from 'react-router';

export class Success extends Component {
  displayName = Success.name
  constructor(props) {
    super(props);
    this.state = {
      location: props.location
    }
  }

  render = () => {
    const { location } = this.state;

    var page = <Redirect to="/hi/dentalforhealth/prevalidate" />

    if (location.success) {
      page = (
        <div className="success-container">
          <div className="middle-screen">
            <h1>Success!</h1>
            <h2>You have been successfully Enrolled in Oral Health for Total Health!</h2>
          </div>
        </div>
      );
    }

    return (
      <div>
        {page}
      </div>
    );
  }
}
